<template>
    <div class="main-container">
        <div class="pywebview-drag-region">
            <div style="width: 35px;line-height: 40px;"><img :src="logoSrc" style="width: 30px;height: 30px;"></div>
            <div style="width: 400px;text-align: left;">全屏找图 版本:{{ version }}</div>
            <div style="width: 100%;text-align: right;">
                <i class="el-icon-minus" style="margin-right: 15px;" @click="setWinMin"></i>
                <i class="el-icon-close" @click="setWinClose"></i>
            </div>
        </div>
        <div class="header">
            <div class="card-head">
                <div style="width: 180px;">会员编号:{{ userId }}</div>
                <div style="width: 160px;" v-if="vipType<2">有效期:{{ vipDate }}</div>
                <div style="width: 160px;" v-if="vipType==2">剩余分钟:{{ lastMinu }}</div>
                <div style="width: 160px;">电话剩余:{{ telQty }}次</div>
                <div class="navBtn" @click="logOut">退出登录</div>
                <div class="navBtn" @click="userPay">会员充值</div>
                <div class="navBtn" @click="clickKeFu">在线客服</div>
                <div class="navBtn" @click="showVideo = true">视频教程</div>
                <div class="navBtn" @click="setUserConfig">配置中心</div>
            </div>
        </div>
        <div class="content">
            <div class="aside">
                <div v-for="(item, index) in tools" :key="index" class="tool" @click="addTask(item)">{{ item }}</div>
                <div class="tool" style="height: 158px;color: #F56C6C;">
                    <br>
                    我们提醒您：<br>
                    应当在合法合规场景下使用本软件,我们不会为违规行为提供任何技术支持，也不提供任何咨询服务。
                    <br>
                </div>
                
            </div>
            <div class="bside">
                <div class="task">
                    <el-table :data="taskList" height="100%" style="width: 100%">
                        <el-table-column fixed="right" label="操作" width="50">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row,scope.$index)" type="text">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="任务类型" width="120">
                            <template slot-scope="scope">
                                <div>{{(scope.$index*1+1)+ scope.row.type }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="启停" width="80">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.running" active-color="#13ce66" inactive-color="#ff4949">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="显示监视框" width="80">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.showSquare" active-color="#13ce66" v-if="scope.row.taskConfig.isFull==0 || scope.row.type!='找图'"
                                    inactive-color="#ff4949" @change="handleSwitchChange(scope.$index)">
                                </el-switch>
                                <div v-if="scope.row.taskConfig.isFull==1">全屏模式</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="显示日志" width="80" >
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.showLog" active-color="#13ce66" inactive-color="#ff4949">
                                </el-switch>
                            </template>
                        </el-table-column>

                        <el-table-column label="任务配置" width="120">
                            <template slot-scope="scope">
                                <el-button type="primary" plain icon="el-icon-setting"
                                    @click="config(scope.row,scope.$index)">配置</el-button>
                            </template>
                        </el-table-column>


                        <el-table-column label="提醒配置" width="120">
                            <template slot-scope="scope">
                                <el-tooltip content="该任务类型无需配置" :disabled="!(scope.row.type=='点击任务'||scope.row.type=='截图任务')">
                                <el-button type="primary" plain icon="el-icon-bell"
                                    @click="remindConfig(scope.row,scope.$index)" :disabled="scope.row.type=='点击任务'||scope.row.type=='截图任务'">配置</el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column label="高级配置" width="120" >
                            <template slot-scope="scope">
                                <el-tooltip content="该任务类型无需配置" :disabled="!(scope.row.type=='点击任务'||scope.row.type=='截图任务')">
                                <el-button type="primary" plain icon="el-icon-s-operation"
                                    @click="advConfig(scope.row,scope.$index)" :disabled="scope.row.type=='点击任务'||scope.row.type=='截图任务'">配置</el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark" placeholder="" />
                            </template>
                        </el-table-column>


                    </el-table>
                </div>
                <div class="log">
                    <div v-html="log" style="padding: 10px;font-size: 12px;"></div>
                </div>
            </div>
        </div>
        <el-dialog title="会员充值，请使用微信扫码支付" :visible.sync="dialogPayVisible" width="600px" :close-on-click-modal="false" @close="dialogPayClose">
            <UserPay v-if="dialogPayVisible" :isBind="isBind"></UserPay>
        </el-dialog>
        <el-dialog :visible.sync="dialogTaskVisible" title="任务配置" width="800px" @close="dialogTaskClose" :close-on-click-modal="false"> 
            <TaskConfig ref="taskConfig" :curTaskIndex="curTaskIndex" :task="curTask" v-if="dialogTaskVisible" @updateShowSquare="updateShowSquare"> </TaskConfig>
        </el-dialog>
        <el-dialog :visible.sync="dialogAdvancedVisible" title="高级配置" width="800px" @close="dialogAdvancedClose" :close-on-click-modal="false"> 
            <AdvancedConfig ref="taskConfig" :curTaskIndex="curTaskIndex" :task="curTask" v-if="dialogAdvancedVisible"> </AdvancedConfig>
        </el-dialog>
        <el-dialog :visible.sync="dialogPersonVisible" title="个人配置" width="880px" @close="dialogPersonClose" :close-on-click-modal="false"> 
            <PersonConfig ref="personConfig"  :personal="personal"> </PersonConfig>
        </el-dialog>
        <el-dialog :visible.sync="dialogRemindVisible" title="提醒配置" width="800px" @close="dialogRemindClose" :close-on-click-modal="false"> 
            <RemindConfig ref="remindConfig"  :curTaskIndex="curTaskIndex" :task="curTask" :soundsList="sounds" v-if="dialogRemindVisible"> </RemindConfig>
        </el-dialog>
        <el-dialog :visible.sync="dialogNoticeVisible" title="公告" width="600px" > 
            <div class="announcement" style="width: 100%; padding: 20px; box-sizing: border-box; background-color: #ffffff; height: 300px;overflow-y: auto;
                border-radius: 8px; margin-right: 20px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
                    <h3 style="color: #303133; font-size: 18px; margin-bottom: 15px;">{{ noticeTitle }}</h3>
                    <p style="color: #606266; font-size: 14px; line-height: 1.5;" v-html="noticeContent"></p>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogLoginVisible" title="登录" width="800px" @close="dialogLoginClose" :close-on-click-modal="false"> 
            <div v-loading="loading" style="display: flex; background-color: #f5f7fa; padding: 20px; border-radius: 8px;">
                <!-- 公告区域 -->
                <div class="announcement" style="width: 55%; padding: 20px; box-sizing: border-box; background-color: #ffffff; height: 300px;overflow-y: auto;
                border-radius: 8px; margin-right: 20px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
                    <h3 style="color: #303133; font-size: 18px; margin-bottom: 15px;">{{ noticeTitle }}</h3>
                    <p style="color: #606266; font-size: 14px; line-height: 1.5;" v-html="noticeContent"></p>
                </div>
                <!-- 登录表单区域 -->
                <div class="login-form"
                    style="width: 45%; padding: 20px; box-sizing: border-box; background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
                    <el-form :model="form">
                    <el-form-item label="手机号" style="margin-bottom: 20px;">
                        <el-input v-model="form.phoneNo" autocomplete="off" placeholder="请输入手机号"
                        style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" style="margin-bottom: 20px;">
                        <el-input v-model="form.verCode" autocomplete="off" placeholder="请输入验证码" style="width: 100%;">
                        <template slot="suffix">
                            <el-button size="mini" type="success" style="color: white; background-color: #67c23a; border: none;"
                            @click="getVerCode" :disabled="isGettinVercode">
                            获取验证码{{ isGettinVercode ? `(${countDown})` : '' }}
                            </el-button>
                        </template>
                        </el-input>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer"
                    style="display: flex; justify-content: space-between;align-items: center;">
                    <div @click="clickKeFu" style="color:#409eff">在线客服<i class="el-icon-chat-dot-round"
                        style="font-size: 22px;color:#409eff;margin-left: 5px;"></i></div>
                    <el-button type="primary" style="background-color: #409eff; border: none; color: white;"
                        @click="clickLogin">登
                        录</el-button>
                    </div>
                </div>
            </div>
            
        </el-dialog>
        <el-dialog title="" :visible.sync="showKeFu" width="350px" :close-on-click-modal="true">
            <div style="width: 100%;text-align: center;">
                <img :src="kefuQR" alt="在线客服" class="base64-image">
            </div>
        </el-dialog>
        <el-dialog title="视频教程  请在以下平台观看" :visible.sync="showVideo">
            <div style="display: flex;flex-direction: column;">
                <div style="padding: 10px;font-size: 18px;font-weight: bold;">微信服务号:全屏找图</div>
                <div style="padding: 10px;font-size: 18px;font-weight: bold;">抖音号:cqtlx998</div>
                <div style="padding: 10px;font-size: 18px;font-weight: bold;">官网:www.qpzt.net</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import TaskConfig from "../components/TaskConfig.vue"
import AdvancedConfig from "./AdvancedConfig.vue";
import PersonConfig from "./PersonConfig.vue";
import RemindConfig from "./RemindConfig.vue";
import UserPay from "./UserPay.vue";
export default {
    components: {
        TaskConfig,
        AdvancedConfig,
        PersonConfig,
        RemindConfig,
        UserPay
    },

    name: "IndexPage",
    data() {
        return {
            dialogTaskVisible:false,
            dialogAdvancedVisible:false,
            dialogPersonVisible:false,
            dialogRemindVisible:false,
            dialogLoginVisible:false,
            dialogPayVisible:false,
            dialogNoticeVisible:true,
            curTaskIndex: -1,
            curTask:null,
            personal:null,
            logoSrc: require('@/assets/logo.png'), // 引用本地图片
            kefuQR: require('@/assets/wxkf.png'), // 引用本地图片
            showKeFu:false,
            showVideo:false,
            version: '2025.0.009',
            userId: '------',
            vipDate: '------',
            lastMinu:0,
            vipType:1,
            telQty:0,
            isBind:0,
            log: ``,
            activeTool: "first",
            tools: ['找图', '找色', '找字',  '变化检测','点击任务'],
            taskList:[],
            logList:[],//要显示日志的任务序号列表
            sounds:[],

            lastArea:{},    //这两个参数用来控制 是否保存区域位置信息，因为python那边每秒都会把位置信息发过来，如果是相同的区域和任务，则是不用保存，节省写入次数
            lastCurrentIndex:-1,

            noticeTitle:'',
            noticeContent:'',
            form:{
                phoneNo:'',
                verCode:''
            },
            isGettinVercode:false,
            countDown:60,
            loading:false,
            mCode:'',
            hasLogin:false,
            soundList:[],
            needOrder:true
            

        }
    },
    watch: { 
        taskList: {
            handler(newVal) {
                console.log('配置信息变化:', newVal);
                window.pywebview.api.setTaskList(newVal)
                this.getShowLogList()
                let count=0
                for(let i in newVal){
                    if(newVal[i].running){
                        count++
                    }
                }
                if(count==0){
                    this.soundList=[]
                    console.log(this.soundList)
                }
            },
            deep: true  // 监听对象内部属性变化
        },
        personal:{
            handler(newVal) {
                console.log('个人配置信息变化:', newVal);
                window.pywebview.api.setPersonal(newVal) 
                let order=newVal.ringOrder||'0'
                this.needOrder=order=='1'         
            },
            deep: true
        }
    },
    mounted() {
        localStorage.removeItem('promotion') //每次启动软件都清除优惠活动标记，避免老用户一直享受优惠
        this.getNotice()
        window.addEventListener('pywebviewready', this.onPyWebviewReady);
        window.printLog = this.printLog;
        window.receiveArea = this.receiveArea; //接收来自python的广播：区域消息
        window.expireNotice = this.expireNotice; //python执行提醒之前会先判断会员是否过期
        window.putSound = this.putSound; //接收到音频并放入列表
        window.useInfoFromBeate = this.useInfoFromBeate;
        //引用全局变量 BASE_API
        //console.log('BASE_API:', this.GLOBAL.BASE_API);
    },
    beforeDestroy() {
        window.removeEventListener('pywebviewready', this.onPyWebviewReady);
    },
    methods: {
        putSound(name){
            if (this.soundList.includes(name)){
                return
            }
            if (this.needOrder){
                this.soundList.push(name)
            }else{
                if (this.soundList.length>0){
                    return
                }else{
                    this.soundList.push(name)
                }
            }
            
            this.playSound(name)
        },
        async playSound(){
            if (this.soundList.length==0){
                return
            }
            let music=this.soundList[0]
            let res=await window.pywebview.api.playSound(music)
            if(res){
                this.soundList.shift();
            }
            setTimeout(() => {
                this.playSound();
            }, 1000);
        },
        clickKeFu(){
            this.showKeFu=true
        },
        clickLogin() {
            let that = this
            if (that.form.verCode == '') {
                that.$message.error('请输入验证码');
                return
            }
            that.loading = true
            this.$post('/api/v9/login', { phone: that.form.phoneNo, code: that.form.verCode, mCode: that.mCode, mName: '' }).then(res => {
                console.log(res)
                if (res.code == 1) {
                    that.loading = false
                    that.userId = res.data.uid
                    that.vipDate = res.data.vipDate
                    that.vipType=res.data.vipType
                    that.isVip = res.data.isVip
                    that.isBind=res.data.isBind
                    that.telQty=res.data.telQty
                    that.lastMinu=res.data.lastMinu
                    that.dialogLoginVisible = false
                    that.hasLogin=true
                    console.log(that.personal)
                    that.personal.userToken=res.token
                    localStorage.setItem('userToken', res.token)
                    localStorage.setItem('promotion',res.data.promotionNo||'')
                    that.getLinkInfo()
                    that.dialogNoticeVisible=false  //从登录界面跳转到通知界面时，要关闭通知界面，因为登录窗口已经看过了
                } else {
                    that.$message.error('验证码不正确');
                }
                that.loading = false
            })

        },

        async getVerCode() {
            const phoneRegex = /^1[3-9]\d{9}$/;
            var that = this
            if (!phoneRegex.test(that.form.phoneNo)) {
                that.$message.error('请输入正确的手机号');
                return
            }
            this.isGettinVercode = true
            let phone = that.form.phoneNo
            let sign = await window.pywebview.api.verCodeSign(phone)
            this.$post('/api/v9/getVercode', { phone: phone, sign: sign }).then(res => {
                if (res.code == 1) {
                    that.countDown = 30
                    that.form.verCode = ''
                    that.$message.success('验证码发送成功');
                    that.countTimer = setInterval(() => {
                        that.countDown--
                        if (that.countDown <= 0) {
                            that.countDown = 30
                            that.isGettinVercode = false
                            clearInterval(that.countTimer)
                        }
                    }
                        , 1000)
                } else {
                    that.$message.error(res.msg);
                }
            })

        },
        addTask(item){
            let task=null
            if(item=="找图"){
                task=this.GLOBAL.FIND_PIC
            }
            if(item=="找色"){
                task=this.GLOBAL.FIND_COLOR
            }
            if(item=="找字"){
                task=this.GLOBAL.FIND_TEXT
            }
            if(item=="变化检测"){
                task=this.GLOBAL.CHECK_CHANGE
            }
            if(item=="点击任务"){
                console.log(this.version)
                if(this.version<5.01){
                    this.$message.error('点击任务功能需要5.01及以上版本才能使用，请前往官网更新到最新版本')
                    return
                }
                task=this.GLOBAL.CLICK_TASK
            }
            if(task!=null){
                this.taskList.push(JSON.parse(JSON.stringify(task)))
                this.$message({
                    message: '添加任务成功',
                    type: 'success'
                });
            }
            
        },
        isNumeric(str) {
            // 匹配：可选正负号 + 数字 + 可选小数部分
            return /^[-+]?\d+(\.\d+)?$/.test(str);
        },
        async onPyWebviewReady() {
            console.log('pywebviewready');
            this.mCode=await window.pywebview.api.getMcode()
            this.taskList=await window.pywebview.api.getTaskList()
            this.personal=await window.pywebview.api.getPersonal()
            try{
                let vsn=await window.pywebview.api.getVersion()
                if(this.isNumeric(vsn)){
                    localStorage.setItem('version', vsn)
                    this.version=vsn
                }else{
                    localStorage.setItem('version', '4.01')
                    this.version='4.01'
                    //主要是以前的版本号用的是2025.0.009这种格式，这样格式的版本号，就直接用4.01代替，强制让它低于5.01
                }
                
            }catch(e){
                console.log('5.01以下版本，没有这个接口')
                console.log(e)
            }
            
            await window.pywebview.api.hideWindow()
            this.getShowLogList()
            console.log(this.mCode)
            await this.checkToken()
            
            
        },
        async getLinkInfo(){
            this.$post('/api/v9/getLinkInfo',{}).then(res=>{
                console.log(res)
                if(res.code==1){ 
                    if(res.data.length==0){
                        //新注册的用户可能还没有添加联系人，直接把当前账户信息添加到联系人中
                        this.personal.personList.push({
                            name:'当前用户',
                            phone:this.userId,
                            workChat:'',
                            wechat:'',
                        })
                    }else{
                        let link=res.data
                        console.log(link)
                        this.personal.personList=link
                    }
                }else{
                    this.$message.error('获取联系人信息失败')
                }
            })

        },
        async checkToken(){
            let token=this.personal.userToken  //决定要不要显示登录框
            console.log('checkToken:',token);
            let res= await this.$post('/api/v9/checkToken',{token:token,mCode:this.mCode})
            console.log('res:',res);
            if(res.code==0){
                this.dialogLoginVisible=true
            }else{
                this.dialogLoginVisible=false
                this.userId=res.data[0].uid
                this.vipDate=res.data[0].vipDate
                this.isBind=res.data[0].isBind
                this.telQty=res.data[0].telQty
                this.isVip=res.data[0].isVip
                this.vipType=res.data[0].vipType
                this.lastMinu=res.data[0].lastMinu
                this.hasLogin=true
                localStorage.setItem('userToken',token)
                localStorage.setItem('promotion',res.data[0].promotionNo||'')
            }
            
        },
        getShowLogList(){
            this.logList=[]
            for(let i in this.taskList){
                if(this.taskList[i].showLog){
                    this.logList.push(i)
                }
            }
        },
        printLog(taskId,log) {
            //return (taskId,log)//暂时不打印
            //console.log(taskId,log);
            //console.log(this.logList);
            //获取当前时间，时分秒格式 HH-mm-ss
            let date = new Date();
            let hours = String(date.getHours()).padStart(2, '0');
            let minutes = String(date.getMinutes()).padStart(2, '0');
            let seconds = String(date.getSeconds()).padStart(2, '0');
            let currentTime = `${hours}:${minutes}:${seconds} `;
            if (this.log.length > 1000) this.log = '';
            if(this.logList.indexOf(taskId)>-1){
                this.log ='【任务'+(taskId*1+1)+'】'+currentTime+'=>'+ log + '<br>' + this.log;
            }
        },
        receiveArea(x,y,w,h,index) {
            if (index < 0) return;
            let area={"x":x*1,"y":y*1,"w":w*1,"h":h*1}
            console.log('接收到区域消息:',JSON.stringify(area));
            //处理区域消息
            if(index==this.lastCurrentIndex && JSON.stringify(area)==JSON.stringify(this.lastArea)){
                //如果是相同的区域和任务，则是不用保存，节省写入次数
                console.log('相同区域，不保存')
                return
            }else{
                this.taskList[index].area=area
            }
            this.lastArea=area
            this.lastCurrentIndex=index
        },
        logOut() {
            this.$confirm('确定要退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 关闭
                let token=localStorage.getItem('userToken')
                this.$post('/api/v9/beateClose',{token:token}).then(res=>{ 
                    console.log(res)
                })
                this.personal.userToken=''
                this.userId = '------'
                this.vipDate = '------'
                this.isBind = 0
                this.telQty = 0
                this.isVip = 0
                this.vipType = 0
                this.lastMinu=0
                this.hasLogin=false
                this.form.phoneNo = ''
                this.form.verCode = ''
                this.dialogLoginVisible=true
            }).catch(() => {
                console.log('取消退出')
            })
        },

        setUserConfig() {
            let personal=this.personal
            if(personal.personList.length==0){
                personal.personList.push({
                    name:'当前用户',
                    phone:this.userId,
                    workChat:'',
                    wechat:'',
                })
            }
            this.dialogPersonVisible = true
        },
        setWinMin() {
            window.pywebview.api.setWindowsMinimize()
        },
        setWinClose() {
            var that=this
            
            //弹出确认对话框，确定后关闭
            this.$confirm('确定要关闭软件吗？', '提示', {
                confirmButtonText: '最小化到托盘',
                cancelButtonText: '关闭软件',
                type: 'warning'
            }).then(() => {
                console.log('最小化到托盘')
                window.pywebview.api.setWindowsIcon()
            }).catch(() => {
                // 关闭
                
                let token=localStorage.getItem('userToken')
                const loading = this.$loading({
                lock: true,
                text: '正在关闭...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
                });
                that.$post('/api/v9/beateClose',{token:token}).then(res=>{ 
                    console.log(res)
                    if(res.code==1){
                        console.log('退出关闭')
                        window.pywebview.api.setWindowsClose()
                    }else{
                        console.log('退出失败')
                        that.$message.error('关闭失败，请重试')
                    }
                    loading.close()
                    
                })
            })

            
        },
        handleClick(row,index) {
            this.$confirm('确定要删除该任务吗？建议您删除任务后重启一下软件，以免任务调度出现异常', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 关闭
                this.taskList.splice(index,1)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {})

        },
        config(row,index) {
            this.curTaskIndex=index
            this.curTask=row
            this.dialogTaskVisible=true
        },
        advConfig(row,index){
            this.curTaskIndex=index
            this.curTask=row
            this.dialogAdvancedVisible=true
        },
        async remindConfig(row,index){
            this.sounds=await window.pywebview.api.getSounds()
            console.log(this.sounds)
            this.curTaskIndex=index
            this.curTask=row
            this.dialogRemindVisible=true
        },
        dialogTaskClose(){

        },
        dialogAdvancedClose(){ 

        },
        dialogPersonClose(){
            var that=this
            this.$post('/api/v9/saveLinkInfo',{link:that.personal.personList}).then(res=>{ 
                    console.log(res)
            })
        },
        dialogRemindClose(){

        },
        dialogLoginClose(){
            if(!this.hasLogin){
                window.pywebview.api.setWindowsClose()
            }
            
        },
        async dialogPayClose(){
            await this.checkToken()
        },
        async userPay(){          
            await this.checkToken()
            console.log('充值')
            this.dialogPayVisible=true
        },
        expireNotice(){
            for(let i in this.taskList){
                this.taskList[i].running=false
            }
            this.$confirm('您的会员已过期，软件无法发出提醒，请及时充值再启动任务。', '会员过期提醒', {
                confirmButtonText: '去充值',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.showCharge = true
            }).catch(() => {})
        },
        updateShowSquare(index){
            console.log('更新显示动作:',index)
            this.taskList[index].showSquare=false
            window.pywebview.api.hideWindow()
        },
        handleSwitchChange(index){
            //console.log(this.taskList[index].showSquare)
            let showSquare=this.taskList[index].showSquare
            if(!showSquare){
                //如果是隐藏动作，则直接调用隐藏接口
                window.pywebview.api.hideWindow()
            }else{
                //如果是显示动作，则先要关闭其它任务的显示
                for(let i in this.taskList){
                    if(this.taskList[i].showSquare && i!=index){
                        this.taskList[i].showSquare=false
                        window.pywebview.api.hideWindow()
                        break
                    }
                }
                //移动窗体到指定位置
                
                let area=this.taskList[index].area

                window.pywebview.api.moveWindow(area["x"],area["y"],area["w"],area["h"])
                window.pywebview.api.showWindow(index)

            }

        },
        useInfoFromBeate(userInfo){
            console.log('收到来自心跳的用户信息:',userInfo)
            this.userId=userInfo.uid
            this.vipDate=userInfo.vipDate
            this.vipType=userInfo.vipType
            this.lastMinu=userInfo.lastMinu
            this.isBind=userInfo.isBind
            this.telQty=userInfo.telQty
            localStorage.setItem('promotion',userInfo.promotionNo||'')
        },
        getNotice(){
            this.$post('/api/v9/getNotice',{version:this.version}).then(res=>{
                console.log(res)
                if(res.code==1){
                    this.noticeTitle=res.data.noticeTitle
                    this.noticeContent=res.data.noticeContent
                }else{
                    this.noticeTitle='公告获取失败'
                    this.noticeContent='公告获取失败'
                }
            })
        }    
    }


}
</script>
<style scoped>
.pywebview-drag-region {
    display: flex;
    flex-direction: row;
    background: #04351a;
    color: white;
    height: 26px;

}

.main-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 96vh;
}

.header {
    width: 100%;
    height: 12vh;
    display: flex;
    flex-direction: row;
}

.content {
    display: flex;
    flex-direction: row;
}

.aside {
    width: 20%;
    height: 85vh;
    border: 1px solid whitesmoke;
}

.bside {
    display: flex;
    flex-direction: column;
    height: 85vh;
    width: 100%;
}

.task {
    height: 50vh;
    border: 1px solid whitesmoke;
}

.log {
    height: 35vh;
    border: 1px solid whitesmoke;
    overflow: auto;
}

.tool {
    border: 1px solid gray;
    height: 25px;
    padding: 15px;
    text-align: center;
    font-size: 14px;
    /*加个手指效果*/
    cursor: pointer;

    /*加个阴影效果*/
    /*box-shadow: 0 0 5px rgba(0,0,0,0.5);*/
}

.navBtn {
    color: #fff;
    width: 80px;
    height: 30px;
    background: #238d53;
    margin: 0 10px;
    border: solid 1px #31cf78;
    border-radius: 3px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;

}

.card-head {
    color: #000;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    background: #f8fafa;
    border: #ccc 1px solid;
    width: 100%;
}
.base64-image {
  max-width: 400px;
  max-height: 300px;
  object-fit: contain;
  /* 确保图片保持比例并缩放以适应容器 */
}
</style>